import React from 'react';


interface IDialogPromptFooterContextType {
    leftNavigationAlwaysList: React.ReactNode[];
    setLeftNavigationAlwaysList: (leftNavigationAlwaysList: React.ReactNode[]) => void;
    leftNavigationList: React.ReactNode[];
    setLeftNavigationList: (leftNavigationList: React.ReactNode[]) => void;
    rightNavigationList: React.ReactNode[];
    setRightNavigationList: (rightNavigationList: React.ReactNode[]) => void;
    actionList: React.ReactNode[];
    setActionList: (actionList: React.ReactNode[]) => void;
    clearFooterList: () => void;
};

const DialogPromptFooterInitialContext = {
    leftNavigationAlwaysList: [],
    setLeftNavigationAlwaysList: () => null,
    leftNavigationList: [],
    setLeftNavigationList: () => null,
    rightNavigationList: [],
    setRightNavigationList: () => null,
    actionList: [],
    setActionList: () => null,
    clearFooterList: () => null,
};
const DialogPromptFooterContext = React.createContext<IDialogPromptFooterContextType>(DialogPromptFooterInitialContext);
export default DialogPromptFooterContext

export const DialogPromptFooterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [leftNavigationAlwaysList, setLeftNavigationAlwaysList] = React.useState<React.ReactNode[]>([]);
    const [leftNavigationList, setLeftNavigationList] = React.useState<React.ReactNode[]>([]);
    const [rightNavigationList, setRightNavigationList] = React.useState<React.ReactNode[]>([]);
    const [actionList, setActionList] = React.useState<React.ReactNode[]>([]);

    const clearFooterList = React.useCallback(() => {
        setLeftNavigationList([])
        setRightNavigationList([])
        setActionList([])
    }, []);

    const contextValue = React.useMemo(() => ({
        leftNavigationAlwaysList, setLeftNavigationAlwaysList,
        leftNavigationList, setLeftNavigationList,
        rightNavigationList, setRightNavigationList,
        actionList, setActionList,
        clearFooterList,
    }), [leftNavigationAlwaysList, leftNavigationList, rightNavigationList, actionList, clearFooterList]);

    return (
        <DialogPromptFooterContext.Provider value={contextValue}>
            {children}
        </DialogPromptFooterContext.Provider>
    );
};
